module.exports = __webpack_public_path__ + "static/media/thumb-earlycollegevote.a74f5296.png";